module.exports = __webpack_public_path__ + "media/images/simulator_banner-d721fe306d1e52a3c1953749cf2d6349.jpg";